/** @jsxImportSource @emotion/react */
import { Table } from "../../../../components/table-components/Table";
import { colors } from "../../../../components/colors";
import { TableRow } from "../../../../components/table-components/TableRow";
import { TableBody } from "../../../../components/table-components/TableBody";
import { TableRowHeader } from "../../../../components/table-components/TableRowHeader";
import { TableCellHeaderText } from "../../../../components/table-components/TableCellHeaderText";
import { StyledText } from "../../../../assets/typography/typography";
import { AdyenSplitConfigurationListItem } from "../../models/adyen-split-configuration";
import { TableCellLink } from "../../../../components/table-components/TableCellLink";
import { routes } from "../../../../appRoutingHelpers";
import { useSelector } from "react-redux";
import * as authSelectors from "../../../auth/authSelectors";
import { useParams } from "react-router";
import { TableEllipsisDropdown } from "../../../../components/TableEllipsisDropdown";
import { DropdownItemLink } from "../../../common/DropdownItemLink";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

type Props = {
  splitConfigurations: AdyenSplitConfigurationListItem[];
};

export const AdyenSplitConfigurationsTable = ({
  splitConfigurations,
}: Props) => {
  const { id } = useParams();
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  return (
    <Table>
      <thead>
        <TableRowHeader>
          <TableCellHeaderText>Description</TableCellHeaderText>
          <TableCellHeaderText>Reference</TableCellHeaderText>
          <th />
        </TableRowHeader>
      </thead>
      <TableBody>
        {splitConfigurations.map((sc, i) => {
          const href = routes.adyenAccountHolderSplitConfigurationInspect(
            organizationKeyName,
            id,
            sc.id
          );
          return (
            <TableRow key={i}>
              <TableCellLink className="pl-5" href={href}>
                <StyledText
                  className="bodyTextRegular mb-0"
                  color={colors.textPrimary}
                >
                  {sc.description || "-"}
                </StyledText>
              </TableCellLink>
              <TableCellLink href={href}>
                <StyledText
                  className="bodyTextRegular mb-0"
                  color={colors.textPrimary}
                >
                  {sc.reference || "-"}
                </StyledText>
              </TableCellLink>
              <TableEllipsisDropdown
                menu={{
                  items: [
                    {
                      key: "1",
                      label: (
                        <DropdownItemLink
                          icon={
                            <FontAwesomeIcon icon={solid("magnifying-glass")} />
                          }
                          to={href}
                        >
                          Edit
                        </DropdownItemLink>
                      ),
                    },
                  ],
                }}
              />
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};
